import type { Task, TaskStatus } from './types'

export interface TaskDropPlacement {
  beforeTaskId: string | null
}

export interface KanbanColumnBounds {
  status: TaskStatus
  left: number
  right: number
  top: number
  bottom: number
}

export function dragGlowStatus(columns: KanbanColumnBounds[], x: number, y: number, activationDistance = 82) {
  const hovered = columns.find(column => x >= column.left && x <= column.right && y >= column.top && y <= column.bottom)
  if (hovered) return hovered.status

  let closest: { status: TaskStatus; distance: number } | undefined
  columns.forEach(column => {
    const horizontalDistance = Math.max(column.left - x, 0, x - column.right)
    const verticalDistance = Math.max(column.top - y, 0, y - column.bottom)
    const distance = Math.hypot(horizontalDistance, verticalDistance)
    if (!closest || distance < closest.distance) closest = { status: column.status, distance }
  })
  return closest && closest.distance <= activationDistance ? closest.status : null
}

export function reorderCampaignTask(tasks: Task[], taskId: string, status: TaskStatus, placement: TaskDropPlacement) {
  const task = tasks.find(item => item.id === taskId)
  if (!task) return tasks

  const remaining = tasks.filter(item => item.id !== taskId)
  const movedTask = task.status === status ? task : { ...task, status }
  const beforeIndex = placement.beforeTaskId
    ? remaining.findIndex(item => item.id === placement.beforeTaskId && item.status === status)
    : -1

  if (beforeIndex >= 0) {
    remaining.splice(beforeIndex, 0, movedTask)
    return remaining
  }

  let lastTaskInColumn = -1
  remaining.forEach((item, index) => {
    if (item.status === status) lastTaskInColumn = index
  })
  remaining.splice(lastTaskInColumn + 1, 0, movedTask)
  return remaining
}
